var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BookModel } from '../BookModel';
import { SchedulingTimeRangeModelCollection } from './SchedulingTimeRangeModelCollection';
import addDays from 'date-fns/addDays';
import startOfDay from 'date-fns/startOfDay';
import getHours from 'date-fns/getHours';
import getMinutes from 'date-fns/getMinutes';
import getSeconds from 'date-fns/getSeconds';
import set from 'date-fns/set';
import isEqual from 'date-fns/isEqual';
import endOfDay from 'date-fns/endOfDay';
import { TimeSlotModel } from './TimeSlotModel';
var DEFAULT_SCHEDULE_INTERVAL_SIZE__MS = 60 * 60 * 1000;
var DEFAULT_SCHEDULE_MIN_MINUTES_BEFORE__MS = 15 * 60 * 1000;
var DEFAULT_MAX_DAYS_IN_THE_FUTURE__DAYS = 0;
var SchedulingTimeRangeModel = /** @class */ (function (_super) {
    __extends(SchedulingTimeRangeModel, _super);
    function SchedulingTimeRangeModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SchedulingTimeRangeModel.getCollectionClass = function () {
        return SchedulingTimeRangeModelCollection;
    };
    SchedulingTimeRangeModel.prototype.getTimeslotModelClass = function () {
        return TimeSlotModel;
    };
    Object.defineProperty(SchedulingTimeRangeModel.prototype, "priority", {
        get: function () {
            var from = this.get("from");
            var to = this.get("to");
            if (from && to) {
                return 20;
            }
            if (from || to) {
                return 10;
            }
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SchedulingTimeRangeModel.prototype, "isIncluding", {
        get: function () {
            return this.get("scheduling_time_range_type_name") === "including";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SchedulingTimeRangeModel.prototype, "intervalSize", {
        get: function () {
            return this.get("interval_size");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SchedulingTimeRangeModel.prototype, "minutesBefore", {
        get: function () {
            return this.get("min_minutes_before");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SchedulingTimeRangeModel.prototype, "maxBookings", {
        get: function () {
            return this.get("max_bookings");
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     * @param timespan Course timespan model
     * @param referenceDateTime date time from which the timeslots to be registered
     * @returns array of timeslots for multiple days from reference days.
     */
    SchedulingTimeRangeModel.prototype.generateRangesForDays = function (maxDaysInFuture, selectedDate) {
        var priority = this.priority;
        var dateTimeSlots = [];
        var weekdayIds = (this.get("week_day_ids") || []);
        var copyTime = function (copyTo, copyFrom) {
            return set(copyTo, {
                hours: getHours(copyFrom),
                minutes: getMinutes(copyFrom),
                seconds: getSeconds(copyFrom),
                milliseconds: 0,
            });
        };
        var referenceDateTime = copyTime(new Date(), this.get("from_time"));
        var dayCounter = 0;
        var completionCounter = maxDaysInFuture;
        do {
            var theDateOfTheWeek = addDays(referenceDateTime, dayCounter);
            if (this.get("is_time_limited") && this.get("from") && this.get("from") > theDateOfTheWeek) {
                dayCounter++;
                completionCounter--;
                continue;
            }
            if (this.get("is_time_limited") && this.get("to") && endOfDay(this.get("to")) < theDateOfTheWeek) {
                dayCounter++;
                completionCounter--;
                continue;
            }
            if (!weekdayIds.includes(theDateOfTheWeek.getDay())) {
                dayCounter++;
                completionCounter--;
                continue;
            }
            if (selectedDate && (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.getTime()) !== startOfDay(theDateOfTheWeek).getTime()) {
                dayCounter++;
                completionCounter--;
                continue;
            }
            var to = copyTime(theDateOfTheWeek, this.get("to_time"));
            to = isEqual(to, startOfDay(to)) ? addDays(to, 1) : to;
            dateTimeSlots.push({
                to: to,
                priority: priority,
                from: theDateOfTheWeek,
                slotInterval: this.intervalSize,
                minutesBefore: this.minutesBefore,
                maxBookings: this.maxBookings
            });
            //dateTimeSlots.push(...this.generateTimeRange(timespan, referenceDateTime, dayCounter))
            dayCounter++;
            completionCounter--;
        } while (completionCounter > 0);
        return dateTimeSlots;
    };
    SchedulingTimeRangeModel.times = ['from_time', 'to_time'];
    SchedulingTimeRangeModel.dates = ['from', 'to'];
    return SchedulingTimeRangeModel;
}(BookModel));
export { SchedulingTimeRangeModel };
